import {adminMenu, contentMenu, gameMenu, studentMenu} from "./menus";

export const useAsideMenusConfig = () => {
    return [adminMenu, studentMenu, contentMenu, gameMenu];
};
